import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { actionItemsSearchSchema, toServerType } from '@/features/action-items/search-schema';
import { actionItemsQueryOptions } from '@/features/action-items/queries';
import { ActionItemsPendingState } from '@/features/action-items/ActionItemsPendingState';
import { requireAuth } from '@/lib/route-guards';

export const actionItemsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/action-items',
  validateSearch: actionItemsSearchSchema,
  beforeLoad: requireAuth,
  // Search params aren't visible to a loader unless declared as deps — without
  // this the loader would prime page 1 while the page asks for `?page=3`.
  loaderDeps: ({ search }) => ({ type: toServerType(search.type), page: search.page }),
  // Prime the list so the first paint isn't a skeleton. Swallow the error — the
  // page renders its own error state with a Retry.
  loader: ({ context: { queryClient }, deps }) =>
    queryClient.ensureQueryData(actionItemsQueryOptions(deps)).catch(() => undefined),
  // `pendingMs`/`pendingMinMs: 0` — no debounce, no artificial display floor
  // (same as `/notifications`).
  pendingComponent: ActionItemsPendingState,
  pendingMs: 0,
  pendingMinMs: 0,
  component: lazyRouteComponent(
    () => import('@/features/action-items/ActionItemsPage'),
    'ActionItemsPage',
  ),
});
